"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArrayOfStrings = exports.TriptychCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _Image = require("../Image");

var _Box = require("../Box");

var _ResponsiveBox = require("../ResponsiveBox");

var _Flex = require("../Flex");

var _Text = require("../Text");

var _excluded = ["images", "title", "subtitle", "status"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var isArrayOfStrings = function isArrayOfStrings(images) {
  return _toConsumableArray(images).every(function (src) {
    return typeof src === "string";
  });
};
/**
 * `TriptychCard` is a card with a layout one square image on the left,
 * one tall or two square images on the right, and text for title and subtitle
 * at the bottom.
 */


exports.isArrayOfStrings = isArrayOfStrings;

var TriptychCard = function TriptychCard(_ref) {
  var images = _ref.images,
      title = _ref.title,
      subtitle = _ref.subtitle,
      status = _ref.status,
      rest = _objectWithoutProperties(_ref, _excluded);

  var imgs = (isArrayOfStrings(images) ? images.map(function (src) {
    return {
      src: src
    };
  }) : images).slice(0, 3);
  return /*#__PURE__*/_react.default.createElement(_Box.Box, rest, /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
    aspectWidth: 3,
    aspectHeight: 2,
    maxWidth: "100%",
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "row",
    width: "100%",
    height: "100%"
  }, function () {
    switch (imgs.length) {
      case 1:
        return /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 3,
          aspectHeight: 2,
          maxWidth: "100%",
          bg: "black10",
          borderRight: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[0])));

      case 2:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 1,
          aspectHeight: 1,
          maxWidth: "100%",
          bg: "black10",
          borderRight: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[0]))), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
          width: "33.33%",
          flexShrink: 0
        }, /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 1,
          aspectHeight: 2,
          maxWidth: "100%",
          bg: "black10",
          borderLeft: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[1])))));

      case 3:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 1,
          aspectHeight: 1,
          maxWidth: "100%",
          bg: "black10",
          borderRight: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[0]))), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
          width: "33.33%",
          flexShrink: 0,
          flexDirection: "column"
        }, /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 1,
          aspectHeight: 1,
          maxWidth: "100%",
          bg: "black10",
          borderLeft: "1px solid",
          borderBottom: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[1]))), /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 1,
          aspectHeight: 1,
          maxWidth: "100%",
          bg: "black10",
          borderLeft: "1px solid",
          borderTop: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[2])))));
    }
  }())), status && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs"
  }, status), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "sm-display"
  }, title), subtitle && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "sm-display",
    color: "black60"
  }, subtitle));
};

exports.TriptychCard = TriptychCard;
TriptychCard.displayName = "TriptychCard";
//# sourceMappingURL=TriptychCard.js.map